// Packages & Memberships demo: there is no backend for these yet, so the catalog lives here
// and the purchase never leaves the browser.

export const PurchaseOfferKinds = {
    Package: 'package',
    Membership: 'membership'
} as const;

export type PurchaseOfferKind = (typeof PurchaseOfferKinds)[keyof typeof PurchaseOfferKinds];

export interface PurchaseOffer {
    id: string;
    kind: PurchaseOfferKind;
    name: string;
    price: number;
    startingAt?: boolean;
    details: Array<string>;
}

// Pet uuid -> ids of the offers picked for that pet, in the order they were picked
export type PurchaseCart = Record<string, Array<string>>;

export const DEMO_PURCHASE_OFFERS: Array<PurchaseOffer> = [
    {
        id: 'package-half-day-2-dogs',
        kind: PurchaseOfferKinds.Package,
        name: '10 Pack Half Day - 2 Dogs',
        price: 400,
        details: ['Daycare Half Day x 10', 'Valid for 2 dogs of the same household']
    },
    {
        id: 'package-3-services',
        kind: PurchaseOfferKinds.Package,
        name: '3 Service Package',
        price: 280,
        startingAt: true,
        details: ['Full Groom x 3', 'Nail Trim x 3', 'Relaxing Massage x 3']
    },
    {
        id: 'package-full-day',
        kind: PurchaseOfferKinds.Package,
        name: '10 Pack Full Day',
        price: 550,
        details: ['Daycare Full Day x 10']
    },
    {
        id: 'membership-3-full-groom',
        kind: PurchaseOfferKinds.Membership,
        name: '3 Full Groom',
        price: 100,
        details: ['Three full grooms every month. Renews automatically, cancel anytime.']
    },
    {
        id: 'membership-3-baths',
        kind: PurchaseOfferKinds.Membership,
        name: '3 Baths',
        price: 40,
        details: ['Three baths every month. Renews automatically, cancel anytime.']
    },
    {
        id: 'membership-2-spa-day',
        kind: PurchaseOfferKinds.Membership,
        name: '2 Spa Day',
        price: 50,
        details: ['Two spa days every month. Renews automatically, cancel anytime.']
    }
];

export const getPurchaseOffer = (id: string): PurchaseOffer | undefined =>
    DEMO_PURCHASE_OFFERS.find(offer => offer.id === id);

export const getPurchaseOffersByKind = (kind: PurchaseOfferKind): Array<PurchaseOffer> =>
    DEMO_PURCHASE_OFFERS.filter(offer => offer.kind === kind);

export const formatPurchaseAmount = (amount: number): string =>
    `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatPurchaseOfferPrice = (offer: PurchaseOffer): string => {
    const price = formatPurchaseAmount(offer.price);

    if (offer.kind === PurchaseOfferKinds.Membership) {
        return `${price}/mo`;
    }

    return offer.startingAt ? `Starting at ${price}` : price;
};

// Memberships charge their first month at checkout
export const getPurchaseCartTotal = (cart: PurchaseCart): number =>
    Object.values(cart)
        .flat()
        .reduce((total, offerId) => total + (getPurchaseOffer(offerId)?.price ?? 0), 0);
